export enum DOCK_CATEGORIES_TYPES {
	ALL = 'all',
	CATTLES = 'cattles',
	FOOD_TABLE = 'food_table',
	HEALTH = 'health',
	MILKING_PROCESS = 'milking_process',
	MILK_YIELD = 'milk_yield',
}
